var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card-text', [_vm.loading ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "table-row@3"
    }
  })], 1)], 1) : _vm._e(), !_vm.loading ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "border-left": "thin solid rgba(255, 255, 255, 0.18) !important"
    }
  }, [_c('v-data-table', {
    staticClass: "table__lined",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "hide-default-footer": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn(_ref) {
        var items = _ref.items;
        return [_c('tbody', _vm._l(items, function (item) {
          return _c('tr', {
            key: item.providerId
          }, [_c('td', [_vm._v(_vm._s(item.providerName))]), _c('td', [_vm._v(_vm._s(item.sourceName))]), _c('td', [_vm._v(_vm._s(item.leadsCount))]), _c('td', [_vm._v(" " + _vm._s(item.contractsCount) + " ("), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.$helper.report.getPercentageHtml(item.contractsCount, item.leadsCount))
            }
          }), _vm._v(") ")]), _c('td', [_vm._v(_vm._s(_vm.$helper.format.currency(item.costTotal)))]), _c('td', [_vm._v(_vm._s(_vm.$helper.format.currency(item.revenueTotal)))]), _c('td', [_c('span', {
            class: _vm.getRoiColor(item.roiPercent)
          }, [_vm._v(" " + _vm._s(Math.round(item.roiPercent)) + "% ")])])]);
        }), 0)];
      }
    }], null, false, 3532099502)
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }